import React, { useState } from 'react';
import { FaLinkedin } from 'react-icons/fa';
import plus from '../../Assets/elvotaimages/plus_g.png';

export default function TeamCard({
  name,
  position,
  additionalText,
  imageSrc,
  linkedinLink,
}) {
  const [isHovered, setIsHovered] = useState(false);
  const [hoverTimeout, setHoverTimeout] = useState(null); // Track timeout

  const handleMouseEnter = () => {
    if (hoverTimeout) {
      clearTimeout(hoverTimeout); // Clear any existing timeout
    }
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    const timeout = setTimeout(() => {
      setIsHovered(false);
    }, 50); // Adjust the delay as needed
    setHoverTimeout(timeout); // Store the timeout ID
  };

  return (
    <div
      className={`relative text-black hover:text-white bg-class-for-test p-4 sm:p-0 h-auto sm:pt-[21px] sm:pb-[47px] sm:px-[25px] rounded-[20px] transition-transform duration-700 ease-in-out ${isHovered ? 'scale-105' : 'scale-100'}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="bg-animated" />

      {/* Image Section */}
      <div className="z-10 relative">
        <img src={imageSrc} className="w-full h-auto" alt={name} />
      </div>

      {/* Text Section */}
      <div className="z-10 relative mt-4">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="f-f-b-ex text-[18px] sm:text-xl">{name}</h1>
            <p className="f-f-r text-lg mt-2">{position}</p>
          </div>
          <div>
            {/* LinkedIn Icon */}
            <a
              href={linkedinLink} // Add the LinkedIn URL here
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 hover:text-white transition duration-300"
            >
              <FaLinkedin size={24} />
            </a>
            <img
              src={plus} // Replace with your image source
              alt="Expand" // Provide an appropriate alt text
              className="w-5 h-5 mt-3 ml-1" // Adjust size as needed
            />
          </div>
        </div>

        {/* Additional text on hover */}
        {isHovered &&
          additionalText.map((text) => (
            <p className="card-content2 pt-5">{text}</p>
          ))}
      </div>
    </div>
  );
}
